module.exports = __webpack_public_path__ + "img/profile.1da4a659.svg";